var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _line, _line2, _line3, _line4, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivechatc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.48 86.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke:#000;}.cls-1,.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-2{stroke-width:5px;}.cls-2,.cls-4{stroke-miterlimit:10;}.cls-3,.cls-4{stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.59,13.1",
    transform: "translate(-0.26 -7.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.07,19.81",
    transform: "translate(-0.26 -7.67)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.71,24.34",
    transform: "translate(-0.26 -7.67)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.31,29.43",
    transform: "translate(-0.26 -7.67)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69,75.68a39.09,39.09,0,0,1-41,9.55l-9.56,7.32-.33-12.61a38.91,38.91,0,1,1,46.1-62.7c.54.4,1.08.81,1.6,1.24",
    transform: "translate(-0.26 -7.67)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.42,49.85",
    transform: "translate(-0.26 -7.67)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.19,49.94",
    transform: "translate(-0.26 -7.67)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.4,39.34a18.05,18.05,0,0,1,18-16.78h0a18.08,18.08,0,0,1,18,17.1",
    transform: "translate(-0.26 -7.67)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.4,39.66h2.26a1,1,0,0,1,1,1V53.84a1,1,0,0,1-1,1H57.89a2.81,2.81,0,0,1-2.79-2.81V42.47a2.81,2.81,0,0,1,2.79-2.81h.51",
    transform: "translate(-0.26 -7.67)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.46,39.66H92.18a1,1,0,0,0-1,1V53.84a1,1,0,0,0,1,1H95a2.81,2.81,0,0,0,2.79-2.81V42.47A2.81,2.81,0,0,0,95,39.66h-.49",
    transform: "translate(-0.26 -7.67)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.48,54.78C93.21,64.56,87.19,68.1,79.9,68.1",
    transform: "translate(-0.26 -7.67)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.22,
    y: 58.18,
    width: 8.21,
    height: 4.49,
    rx: 0.16
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.62,
    y1: 36.72,
    x2: 46.34,
    y2: 36.92
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.55,
    y1: 45.45,
    x2: 46.34,
    y2: 45.66
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.29,
    y1: 53.78,
    x2: 38.89,
    y2: 53.78
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.48,
    y1: 53.78,
    x2: 34.1,
    y2: 53.78
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.39,61.45",
    transform: "translate(-0.26 -7.67)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.33,61.45",
    transform: "translate(-0.26 -7.67)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.92,46.7",
    transform: "translate(-0.26 -7.67)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.86,47.42",
    transform: "translate(-0.26 -7.67)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechatc);
export default __webpack_public_path__ + "static/media/livechatc.d5d5aa1aca02e8703654e2cf1fe5360b.svg";
export { ForwardRef as ReactComponent };